


























import TimeRangeControls from "@/components/TimeRangeControls.vue";
import ProcessedStatsChart from "@/components/ProcessedStatsChart.vue";
import { DataStatus } from "@/types/common";
import { Settings } from "@/types/settings";
import GetProcessedStats from "@/mixins/get-processed-stats";
import GetPerServerProcessedStats from "@/mixins/get-per-server-processed-stats";
import { getTitle } from "@/utils/chart";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Route } from "vue-router";

@Component({
  components: { TimeRangeControls, ProcessedStatsChart },
})
export default class MetricView extends Mixins(GetProcessedStats, GetPerServerProcessedStats) {
  created() {
    this.getProcessedStats();
    this.getPerServerProcessedStats();
    this.chartID = this.$route.params.metricId;
  }

  beforeDestroy() {
    this.cleanUpProcessedStats();
    this.cleanUpPerServerProcessedStats();
  }

  // route param changes are not reactive, so watch for updates
  @Watch("$route")
  onRouteUpdate(to: Route, from: Route) {
    if (to.params.metricId !== from.params.metricId) {
      this.chartID = to.params.metricId;
    }
  }

  @Getter("processedStats/perServerSeriesName") perServerSeriesName!: (chartID: string, chartIndex: number) => string;
  @Getter("processedStats/perServerSeriesStatus") perServerSeriesStatus!: DataStatus;
  @Getter("settings/activeCacheSettings") settings!: Settings;

  chartID = "";

  get chartTitle(): string {
    return getTitle(this.chartID);
  }
}
